var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchXlWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5833 30.3333H31.8717L31.265 29.7483C33.3883 27.2783 34.6667 24.0717 34.6667 20.5833C34.6667 12.805 28.3617 6.5 20.5833 6.5C12.805 6.5 6.5 12.805 6.5 20.5833C6.5 28.3617 12.805 34.6667 20.5833 34.6667C24.0717 34.6667 27.2783 33.3883 29.7483 31.265L30.3333 31.8717V33.5833L41.1667 44.395L44.395 41.1667L33.5833 30.3333ZM20.5833 30.3333C15.1883 30.3333 10.8333 25.9783 10.8333 20.5833C10.8333 15.1883 15.1883 10.8333 20.5833 10.8333C25.9783 10.8333 30.3333 15.1883 30.3333 20.5833C30.3333 25.9783 25.9783 30.3333 20.5833 30.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchXlWhite);
export default __webpack_public_path__ + "static/media/icon-search-xl-white.c68892380346c627d8a79fbfb29fa645.svg";
export { ForwardRef as ReactComponent };